module.exports = __webpack_public_path__ + "img/bg-img-one.5bc8262d.png";